import { useEffect, useState, useRef } from 'react';
import './UpdateBanner.css';

const CHECK_INTERVAL = 2 * 60 * 1000; // 2 percenként

export default function UpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false);
  const currentVersion = useRef(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        const data = await res.json();

        if (!currentVersion.current) {
          // Első betöltés – elmentjük az aktuális verziót
          currentVersion.current = data.version;
        } else if (data.version !== currentVersion.current) {
          // Új verzió érhető el!
          setShowUpdate(true);
        }
      } catch {
        // Hálózati hiba – nem gond
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  if (!showUpdate) return null;

  return (
    <div className="update-banner">
      <span><i className="ti ti-refresh"></i> Új verzió érhető el!</span>
      <button onClick={() => window.location.reload()}>Frissítés</button>
    </div>
  );
}